import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=23724f56&scoped=true"
import script from "./robot.vue?vue&type=script&lang=js"
export * from "./robot.vue?vue&type=script&lang=js"
import style0 from "./robot.vue?vue&type=style&index=0&id=23724f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23724f56",
  null
  
)

export default component.exports